// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, FileText, Shield, FileCheck, Info, AlertCircle,CookieIcon, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-100 border-t">
      {/* תוכן ראשי של הפוטר */}
      <div className="container mx-auto px-4 py-8">
        <div className="grid md:grid-cols-3 gap-8">
          {/* לינקים חשובים */}
          <div>
            <h3 className="text-lg font-bold text-gray-700 mb-4">מידע חשוב</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-600 hover:text-blue-600 flex items-center gap-2">
                  <Info className="w-4 h-4" />
                  אודות המערכת
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-600 hover:text-blue-600 flex items-center gap-2">
                  <Shield className="w-4 h-4" />
                  מדיניות פרטיות
                </Link>
              </li>
              <li>
                <Link to="/accessibility" className="text-gray-600 hover:text-blue-600 flex items-center gap-2">
                  <FileCheck className="w-4 h-4" />
                  הצהרת נגישות
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-600 hover:text-blue-600 flex items-center gap-2">
                  <FileText className="w-4 h-4" />
                  תנאי שימוש
                </Link>
              </li>
                    <li>
                <Link to="/cookie-policy" className="text-gray-600 hover:text-blue-600 flex items-center gap-2">
                  <CookieIcon className="w-4 h-4" />
                 מדיניות עוגיות
                </Link>
              </li>
                          <li>
                <Link to="/legal-disclaimer" className="text-gray-600 hover:text-blue-600 flex items-center gap-2">
                  <FileText className="w-4 h-4" />
                  כתב ויתור משפטי
                </Link>
                    <Link to="/contact" className="text-gray-600 hover:text-blue-600 flex items-center gap-2">
                  <Phone className="w-4 h-4" />
                  יצירת קשר
                </Link>
              </li>
            </ul>
          </div>




          {/* הבהרה משפטית */}
          <div>
            <h3 className="text-lg font-bold text-gray-700 mb-4 flex items-center gap-2">
              <AlertCircle className="w-5 h-5 text-blue-600" />
              הבהרה משפטית
            </h3>
            <div className="text-sm text-gray-600 space-y-3">
              <p>
                📊 המידע באתר גמל נט AI נועד להנגיש תובנות והשוואות, אך אינו מהווה ייעוץ פנסיוני, פיננסי או השקעות.
              </p>
              <p>
                📄✅ כל החלטה צריכה להיעשות תוך התאמה אישית ובליווי בעל רישיון מוסמך בלבד.
              </p>
              <p>
                ⏳ תשואות עבר אינן מעידות בהכרח על ביצועים עתידיים, ואין לראות בנתונים באתר התחייבות או המלצה.
              </p>
              <p>
                🧠 אנו עושים מאמץ כנה בשילוב מערכות בינה מלאכותית מתקדמות לספק מידע מדויק, אך האחריות לשימוש בו ולפרשנותו היא בידי המשתמש בלבד.
              </p>
            </div>
          </div>

          {/* אבטחת מידע */}
          <div>
            <h3 className="text-lg font-bold text-gray-700 mb-4">אבטחת מידע</h3>
            <p className="text-sm text-gray-600">
              האתר עושה שימוש בטכנולוגיות אבטחה מתקדמות, כולל תעודת SSL,
              כדי להצפין את המידע המועבר ולהבטיח את פרטיותכם.
            </p>
          </div>
        </div>
      </div>

      {/* קרדיט ויוצרים */}
      <div className="border-t">
        <div className="container mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-600">
            <div>
              © {new Date().getFullYear()} כל הזכויות שמורות לגמלנט AI.
            </div>
            <div className="flex items-center gap-2">
              <span>אתר זה פותח ע"י</span>
              <a  
                href="mailto:michaelharush551@gmail.com"
                className="text-blue-600 hover:text-blue-800 font-medium"
              >
                <div className="flex items-center gap-1">
                  MH Site Development
                  <Mail className="w-4 h-4" />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;